import './App.css';
import { isMobile} from "react-device-detect"
import { HashRouter as Router, Routes, Route} from "react-router-dom";
import Navigator from './Navigator';
import About from './About';
import Content from './Content';
import Philosophy from './Philosophy';
import Contact from './Contact';
import React, { useEffect } from "react";

function App() {
  useEffect(() => {
    document.title = "DigitalMinhwa";
  }, []);
  return (
    <Router>
    <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=inter"/>
    <div className="App">
      <Navigator>
      </Navigator>
      <div className="body">
          <Routes>
              <Route path="/" element={<Content/>} />
              <Route path="/about" element={<About/>} />
              <Route path="/philosophy" element={<Philosophy/>} />
              <Route path="/contact" element={<Contact/>} />
          </Routes>
      </div>
    </div>
    </Router>
  );
}

export default App;
